import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import {
  ToolbarButton,
  Avatar,
  Toast,
  useId,
  Toaster,
  shorthands,
  tokens,
  makeStyles,
  RadioGroup,
  Radio,
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogActions,
  Button,
  useToastController,
} from '@fluentui/react-components';
import {Navigation24Regular , Building24Regular,Location24Regular, AppsList24Regular, Grid24Regular, Person24Regular, SignOut24Regular,LocalLanguage24Regular  } from '@fluentui/react-icons';
import { supportedLanguages, uiText } from '@/i18n/locales';
import { useUserPrefs } from '@/context/UserPrefsContext';
import locationData from '@/data/locations.json';
import { loginUser, signupUser } from '@/services/userService';
import { useNavigate } from 'react-router-dom';
import { CategoryTabs } from './CategoryTabs';
// import { AppsList24Regular } from 'node_modules/@fluentui/react-icons/lib/fonts/sizedIcons/chunk-18';

const useStyles = makeStyles({
  root: {
    ...shorthands.padding('8px', '12px'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    position: 'sticky',
    top: 0,
    backgroundColor: tokens.colorNeutralBackground1,
    zIndex: 10,
  },
  selectMenu: {
  minWidth: '80px',   // smaller than before
  maxWidth: '120px',  // optional limit
  padding: '4px',
  borderRadius: tokens.borderRadiusMedium,
  border: `1px solid ${tokens.colorNeutralStroke2}`,
  backgroundColor: tokens.colorNeutralBackground1,
  fontSize: '14px',
}
  ,
  title: { fontSize: '18px', fontWeight: 600 },
  right: { display: 'flex', alignItems: 'center', gap: '8px' },
  viewButton: { borderRadius: tokens.borderRadiusMedium },
  active: { backgroundColor: tokens.colorNeutralBackground3 },
  languageGroup: { marginRight: '12px' },
  // selectMenu: { minWidth: '200px' },
  input: { width: '100%', padding: '4px', marginBottom: '6px', boxSizing: 'border-box' },
});

export interface HeaderRef {
  openLogin: () => void;
}

export const Header = forwardRef<HeaderRef>((props, ref) => {
  const [showTabs, setShowTabs] = useState(true);
const [showMobileLanguageSelect, setShowMobileLanguageSelect] = useState(false);


  const styles = useStyles();
  const { prefs, setPrefs } = useUserPrefs();
  const toastId = useId('toast');
  const { dispatchToast } = useToastController(toastId);
  const isLoggedIn = Boolean(prefs.userId);
       const [loginEmail, setLoginEmail] = useState(prefs.email || '');
  const [selectedLanguage, setSelectedLanguage] = useState<string>(prefs.language);
  const [selectedCountry, setSelectedCountry] = useState<string>(prefs.country || '');
  const [selectedState, setSelectedState] = useState<string>(prefs.state || '');
  const [selectedCity, setSelectedCity] = useState<string>(prefs.city || '');
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [loginName, setLoginName] = useState(prefs.userName || '');
  const [loginPassword, setLoginPassword] = useState('');

  const [showLocationPicker, setShowLocationPicker] = useState(false);
const navigate = useNavigate();

const goHome = () => {
  navigate('/');
};
  
  const t = uiText[prefs.language] ?? uiText.en;
const [isMobile, setIsMobile] = useState(false);

useEffect(() => {
  if (!window.matchMedia) return;

  const mediaQuery = window.matchMedia('(max-width: 640px)');

  // Set initial value
  setIsMobile(mediaQuery.matches);

  // Listener
  const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
  mediaQuery.addEventListener('change', handler);

  return () => mediaQuery.removeEventListener('change', handler);
}, []);




const selectWidth = isMobile ? 120 : 90;

  const countryMap: Record<string, Record<string, string[]>> = {};
  locationData.forEach(({ Country, State, City }) => {
    if (!countryMap[Country]) countryMap[Country] = {};
    if (!countryMap[Country][State]) countryMap[Country][State] = [];
    if (!countryMap[Country][State].includes(City)) countryMap[Country][State].push(City);
  });

  useImperativeHandle(ref, () => ({
    openLogin: () => setShowLoginPopup(true),
  }));

  useEffect(() => {
    if (selectedCountry && !countryMap[selectedCountry]?.[selectedState]) {
      setSelectedState('');
      setSelectedCity('');
    }
    if (selectedState && !countryMap[selectedCountry][selectedState]?.includes(selectedCity)) {
      setSelectedCity('');
    }
  }, [selectedCountry, selectedState]);

  const [loginError, setLoginError] = useState<string | null>(null);

const handleLogin = async () => {
  const name = loginName.trim();
  const password = loginPassword.trim();
  if (!name || !password) {
    setLoginError('Username and password required');
    return;
  }

  try {
    // Try login first
    const user = await loginUser(name, password);
    setPrefs({ ...prefs, userId: user.id, userName: user.name, email: user.email });
    dispatchToast(<Toast>👋 Welcome back</Toast>, { intent: 'success', timeout: 2000 });
    setShowLoginPopup(false);
    setLoginError(null);
  } catch (loginErr: any) {
    // If login failed, try signup
    try {
      const user = await signupUser(name, prefs.email, password);
      setPrefs({ ...prefs, userId: user.id, userName: user.name, email: user.email ?? undefined });
      dispatchToast(<Toast>🎉 Account created</Toast>, { intent: 'success', timeout: 2000 });
      setShowLoginPopup(false);
      setLoginError(null);
    } catch (signupErr: any) {
      // Show duplicate username / other errors inside popup
      setLoginError(signupErr.message || 'Login/Signup failed');
    }
  }
};


  return (
    <>
    <header className={styles.root}>
      <div
  className={styles.title}
onClick={() => setShowTabs(prev => !prev)}
  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
>
      <Navigation24Regular  />
{!isMobile && (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <div
      style={{
        width: 4,
        height: 22,
        background: '#C40000',
        marginRight: 6,
        borderRadius: 2,
      }}
    />
    <span
      style={{
        fontSize: 20,
        fontWeight: 700,
        letterSpacing: '-0.2px',
      }}
    >
      {t.title}
    </span>
  </div>
)}


</div>


      {/* View mode */}
      <div style={{ display: 'flex', gap: 4 }}>
        <ToolbarButton
          icon={<AppsList24Regular  />}
          aria-label="Simple list view"
          className={prefs.viewMode === 'simple' ? styles.active : styles.viewButton}
          onClick={() => setPrefs({ ...prefs, viewMode: 'simple' })}
        />
        <ToolbarButton
          icon={<Grid24Regular />}
          aria-label="Card view"
          className={prefs.viewMode === 'regular' ? styles.active : styles.viewButton}
          onClick={() => setPrefs({ ...prefs, viewMode: 'regular' })}
        />
      </div>

      <div className={styles.right}>
          <div style={{ position: 'relative' }}>
          {/* Mobile icon */}
          {isMobile && (
            <ToolbarButton
              icon={<LocalLanguage24Regular />}
              aria-label="Change language"
              onClick={() => setShowMobileLanguageSelect(prev => !prev)}
            />
          )}

          {/* Language selector */}
          {!isMobile ? (
            // Desktop: standard select
            <select
              className={styles.selectMenu}
              value={prefs.language}
              onChange={e => setPrefs({ ...prefs, language: e.target.value })}
              style={{ width: 60 }}
            >
              {[...supportedLanguages]
                .sort((a, b) => {
                  const priority = ['english', 'español', '中文', 'العربية'];
                  const ai = priority.indexOf(a.label.toLowerCase());
                  const bi = priority.indexOf(b.label.toLowerCase());
                  if (ai !== -1 || bi !== -1) {
                    if (ai === -1) return 1;
                    if (bi === -1) return -1;
                    return ai - bi;
                  }
                  return a.label.localeCompare(b.label);
                })
                .map(l => (
                  <option key={l.code} value={l.code}>
                    {l.label.toUpperCase()}
                  </option>
                ))}
            </select>
          ) : (
            // Mobile: show list only when icon clicked
            showMobileLanguageSelect && (
              <div
                style={{
                  position: 'absolute',
                  top: '36px',
                  right: 0,
                  background: tokens.colorNeutralBackground1,
                  border: `1px solid ${tokens.colorNeutralStroke2}`,
                  borderRadius: tokens.borderRadiusMedium,
                  zIndex: 100,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                  minWidth: 120,
                }}
              >
                {[...supportedLanguages]
                  .sort((a, b) => {
                    const priority = ['english', 'español', '中文', 'العربية'];
                    const ai = priority.indexOf(a.label.toLowerCase());
                    const bi = priority.indexOf(b.label.toLowerCase());
                    if (ai !== -1 || bi !== -1) {
                      if (ai === -1) return 1;
                      if (bi === -1) return -1;
                      return ai - bi;
                    }
                    return a.label.localeCompare(b.label);
                  })
                  .map(lang => (
                    <div
                      key={lang.code}
                      onClick={() => {
                        setPrefs({ ...prefs, language: lang.code });
                        setShowMobileLanguageSelect(false);
                      }}
                      style={{
                        padding: '6px 12px',
                        cursor: 'pointer',
                        backgroundColor:
                          prefs.language === lang.code
                            ? tokens.colorNeutralBackground3
                            : 'transparent',
                        fontWeight: prefs.language === lang.code ? 600 : 400,
                      }}
                    >
                      {lang.label}
                    </div>
                  ))}
              </div>
            )
          )}
        </div>


{/* ---------- Location button: Local ---------- */}
<ToolbarButton
  icon={
    <Location24Regular
      style={{ color: '#FF5722', fontSize: '24px' }} // orange color
    />
  }
  appearance="subtle"
  aria-label="Set local city"
  
  onClick={async () => {
    try {
      const res = await fetch('https://ipapi.co/json/');
      const data = await res.json();
      if (!data.latitude || !data.longitude) return;

      // Find nearest city in the selected country
      const countryCities = locationData.filter(c => c.Country === selectedCountry);
      if (countryCities.length === 0) return;

      const toRad = (v: number) => (v * Math.PI) / 180;
      const distanceKm = (lat1: number, lng1: number, lat2: number, lng2: number) => {
        const R = 6371;
        const dLat = toRad(lat2 - lat1);
        const dLng = toRad(lng2 - lng1);
        const a =
          Math.sin(dLat / 2) ** 2 +
          Math.cos(toRad(lat1)) *
            Math.cos(toRad(lat2)) *
            Math.sin(dLng / 2) ** 2;
        return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      };

      let nearest = countryCities[0];
      let minDistance = Infinity;

      for (const c of countryCities) {
        const d = distanceKm(data.latitude, data.longitude, c.lat, c.lng);
        if (d < minDistance) {
          minDistance = d;
          nearest = c;
        }
      }

      setSelectedCountry(nearest.Country);
      setSelectedState(nearest.State);
      setSelectedCity(nearest.City);
      setPrefs({
        ...prefs,
        country: nearest.Country,
        state: nearest.State,
        city: nearest.City,
      });
    } catch (err) {
      console.error('Failed to get local city', err);
    }
  }}
>
  {!isMobile && <span style={{ marginLeft: 4 }}>Local</span>}
</ToolbarButton>

{/* Location selector */}
{!isMobile ? (
<div
  style={{
    display: 'flex',
    gap: 4,
    alignItems: 'center',
  }}
>

  {/* Country */}
  <select
    className={styles.selectMenu} style={{ width: selectWidth }}
    value={selectedCountry}
    onChange={e => {
      const country = e.target.value;
      setSelectedCountry(country);
      setSelectedState('');
      setSelectedCity('');
      setPrefs({ ...prefs, country, state: '', city: '' });
    }}
  >
    <option value="">Select Country</option>
{Object.keys(countryMap)
  .sort((a, b) => {
    const priority = ['USA', 'Canada'];

    const ai = priority.indexOf(a);
    const bi = priority.indexOf(b);

    if (ai !== -1 || bi !== -1) {
      if (ai === -1) return 1;
      if (bi === -1) return -1;
      return ai - bi;
    }

    return a.localeCompare(b);
  })
  .map(c => (
    <option key={c} value={c}>
      {c}
    </option>
  ))}

  </select>

  {/* State */}
  <select
    className={styles.selectMenu} style={{ width: selectWidth }}
    value={selectedState}
    onChange={e => {
      const state = e.target.value;
      setSelectedState(state);
      setSelectedCity('');
      setPrefs({ ...prefs, state, city: '' });
    }}
    disabled={!selectedCountry}
  >
    <option value="">Select State</option>
    {selectedCountry &&
      Object.keys(countryMap[selectedCountry])
  .sort((a, b) => a.localeCompare(b))
  .map(s => (

        <option key={s} value={s}>
          {s}
        </option>
      ))}
  </select>

  {/* City */}
  <select
    className={styles.selectMenu} style={{ width: selectWidth }}
    value={selectedCity}
    onChange={e => {
      const city = e.target.value;
      setSelectedCity(city);
      setPrefs({ ...prefs, city });
    }}
    disabled={!selectedState}
  >
    <option value="">Select City</option>
    {selectedCountry &&
      selectedState &&
      [...countryMap[selectedCountry][selectedState]]
  .sort((a, b) => a.localeCompare(b))
  .map(city => (

        <option key={city} value={city}>
          {city}
        </option>
      ))}
  </select>
</div>
) : (
  /* ---------- Mobile: compact button ---------- */
  <ToolbarButton
    icon={<Building24Regular />}
    aria-label="Change location"
    onClick={() => setShowLocationPicker(true)}
  />
)}

        {/* Login / Account Button */}
        <ToolbarButton
          icon={isLoggedIn ? <Avatar name={prefs.userName} /> : <Person24Regular />}
           style={{ color: '#2207bb', fontSize: '24px' }} // orange color
          onClick={() => setShowLoginPopup(true)}
        />
          <Dialog
            open={showLocationPicker}
            onOpenChange={(_, d) => setShowLocationPicker(d.open)}
          >
            <DialogSurface>
              <DialogBody>
                <DialogTitle>Select location</DialogTitle>

                {/* Country */}
                <select
                  className={styles.selectMenu}
                  value={selectedCountry}
                  onChange={e => {
                    const country = e.target.value;
                    setSelectedCountry(country);
                    setSelectedState('');
                    setSelectedCity('');
                    setPrefs({ ...prefs, country, state: '', city: '' });
                  }}
                >

                  {Object.keys(countryMap)
                      .sort((a, b) => {
                        const priority = ['USA', 'Canada'];

                        const ai = priority.indexOf(a);
                        const bi = priority.indexOf(b);

                        if (ai !== -1 || bi !== -1) {
                          if (ai === -1) return 1;
                          if (bi === -1) return -1;
                          return ai - bi;
                        }

                        return a.localeCompare(b);
                      })
                      .map(c => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                </select>

                {/* State */}
                <select
                  className={styles.selectMenu}
                  value={selectedState}
                  disabled={!selectedCountry}
                  onChange={e => {
                    const state = e.target.value;
                    setSelectedState(state);
                    setSelectedCity('');
                    setPrefs({ ...prefs, state, city: '' });
                  }}
                >
                  <option value="">State</option>
              {selectedCountry &&
                Object.keys(countryMap[selectedCountry])
            .sort((a, b) => a.localeCompare(b))
            .map(s => (

                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
                </select>

                {/* City */}
                <select
                  className={styles.selectMenu}
                  value={selectedCity}
                  disabled={!selectedState}
                  onChange={e => {
                    const city = e.target.value;
                    setSelectedCity(city);
                    setPrefs({ ...prefs, city });
                  }}
                >
                  <option value="">City</option>
              {selectedCountry &&
                selectedState &&
                [...countryMap[selectedCountry][selectedState]]
            .sort((a, b) => a.localeCompare(b))
            .map(city => (

                  <option key={city} value={city}>
                    {city}
                  </option>
                ))}
                </select>

                <DialogActions>
                  <Button appearance="primary" onClick={() => setShowLocationPicker(false)}>
                    Done
                  </Button>
                </DialogActions>
              </DialogBody>
            </DialogSurface>
          </Dialog>



        <Dialog open={showLoginPopup} onOpenChange={(e, data) => setShowLoginPopup(data.open)}>
          <DialogSurface>
            <DialogBody>
              <DialogTitle>{isLoggedIn ? 'Account' : 'Login / Sign up'}</DialogTitle>

              {!isLoggedIn && (
                <>
                  <input
                    placeholder="Username"
                    className={styles.input}
                    value={loginName}
                    onChange={e => setLoginName(e.target.value)}
                  />
                  <input
                    placeholder="Password"
                    type="password"
                    className={styles.input}
                    value={loginPassword}
                    onChange={e => setLoginPassword(e.target.value)}
                  />
                  <input
                    placeholder="Email (optional)"
                    type="email"
                    className={styles.input}
                    value={loginEmail}
                    onChange={e => setLoginEmail(e.target.value)}
                  />
                  {loginError && (
                    <div style={{ color: 'red', fontSize: 12, marginBottom: 6 }}>{loginError}</div>
                  )}
                  <DialogActions>
                    <Button
                      appearance="primary"
                      onClick={async () => {
                        const name = loginName.trim();
                        const password = loginPassword.trim();
                        const email = loginEmail.trim() || undefined;
                        if (!name || !password) {
                          setLoginError('Username and password required');
                          return;
                        }
                        try {
                          // Login first
                          const user = await loginUser(name, password);
                          setPrefs({ ...prefs, userId: user.id, userName: user.name, email: user.email });
                          dispatchToast(<Toast>👋 Welcome back</Toast>, { intent: 'success', timeout: 2000 });
                          setShowLoginPopup(false);
                          setLoginError(null);
                        } catch {
                          // Signup if login fails
                          try {
                            const user = await signupUser(name, email, password);
                            setPrefs({ ...prefs, userId: user.id, userName: user.name, email: user.email ?? undefined, });
                            dispatchToast(<Toast>🎉 Account created</Toast>, { intent: 'success', timeout: 2000 });
                            setShowLoginPopup(false);
                            setLoginError(null);
                          } catch (err: any) {
                            setLoginError(err.message || 'Login/Signup failed');
                          }
                        }
                      }}
                    >
                      Login / Sign up
                    </Button>
                  </DialogActions>
                </>
              )}

              {isLoggedIn && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <div>
                    <strong>Username:</strong> {prefs.userName} <br />
                    <small style={{ color: 'orange' }}>⚠️ Username cannot be changed</small>
                  </div>
                  <div>
                    <strong>Email:</strong> {prefs.email || 'Not provided'}
                  </div>
                  <div>
                    <strong>Password:</strong> ******** <br />
                    <small style={{ color: 'orange' }}>⚠️ Password cannot be changed</small>
                  </div>
                  <DialogActions>
                    <Button
                      icon={<SignOut24Regular />}
                      onClick={() => setPrefs({ ...prefs, userId: undefined, userName: undefined, email: undefined })}
                    >
                      Logout
                    </Button>
                  </DialogActions>
                </div>
              )}
            </DialogBody>
          </DialogSurface>
        </Dialog>

      </div>

      <Toaster toasterId={toastId} />
    </header>
           {showTabs && <CategoryTabs />}
          </>
  );
});
